import { userConstants } from '../../_constants';

const initialState = { setPasswordLoading: true, data: '', error: false };

export function setPasswordReducer(state = initialState, action) {
    
    switch (action.type) {
        case userConstants.REQUEST_FORGOT_PASSWORD:
            return {
                setPasswordLoading: true,
                data: '',
                error: false
            };
        case userConstants.RECEIVE_FORGOT_PASSWORD:
            return {
                setPasswordLoading: false,
                data: action.setPassword,
                error: false
            };
        case userConstants.FORGOT_PASSWORD_ERROR:
            return {
                setPasswordLoading: false,
                data: '',
                error: true
            };
        default:
            return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/User/setPassword.reducer.js